<template>
    <v-data-table
            class="application-permissions"
            :headers="headers"
            :items="permissions"
            :loading="loading"
            no-data-text="Keine Daten verfügbar"
            hide-default-footer
            disable-pagination
    >
        <template slot="item" slot-scope="props">
            <tr>
                <td> {{ props.item.id }}</td>
                <td> {{ props.item.appName }}</td>
                <td> {{ props.item.userInfo.name }}</td>
                <td> {{ props.item.userInfo.email }}</td>
                <td> {{ props.item.user_id }}</td>
                <td> {{ props.item.createdAt | toDatetime }}</td>
                <td> {{ props.item.updatedAt | toDatetime }}</td>
                <td>
                    <v-btn
                            text
                            icon
                            class="drei_60-btn"
                            @click="editPermission(props.item.id)"
                            :disabled="loading"
                    >
                        <v-icon>mdi-square-edit-outline</v-icon>
                    </v-btn>
                </td>
            </tr>
        </template>
    </v-data-table>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    name: 'ApplicationPermissions',
    computed: mapState('applicationPermissions', [
        'loading',
        'permissions',
    ]),
    data() {
        return {
            headers: [{
                text: '#',
                align: 'left',
                sortable: true,
                value: 'id',
            }, {
                text: 'App',
                align: 'left',
                sortable: true,
                value: 'appName',
            }, {
                text: 'Name',
                align: 'left',
                sortable: true,
                value: 'userInfo.name',
            }, {
                text: 'Email',
                align: 'left',
                sortable: true,
                value: 'userInfo.email',
            }, {
                text: 'SSO ID',
                align: 'left',
                sortable: true,
                value: 'user_id',
            }, {
                text: 'Erstellt',
                align: 'left',
                sortable: true,
                value: 'createdAt',
            }, {
                text: 'Aktualisiert',
                align: 'left',
                sortable: true,
                value: 'updatedAt',
            }, {
                text: 'Editieren',
                align: 'left',
                sortable: false,
                value: 'id',
            }],
        };
    },
    methods: {
        ...mapActions('applicationPermissions', ['editPermissionById']),
        editPermission(id) {
            this.editPermissionById(id).catch(() => null);
        },
    },
};

</script>
<style scoped lang="scss"></style>
